export const NEW_PROVIDER_NUMBER = 'NEW_PROVIDER_NUMBER';

export const PULL_PROVIDER_NUMBER = 'PULL_PROVIDER_NUMBER';

export const ASSIGN_PROVIDER_NUMBER_INSURANCE_COMPANY = 'ASSIGN_PROVIDER_NUMBER_INSURANCE_COMPANY';
export const ASSIGN_PROVIDER_NUMBER_CODE = 'ASSIGN_PROVIDER_NUMBER_CODE';

export const LIST_PROVIDER_NUMBERS_SUCCESS = 'LIST_PROVIDER_NUMBERS_SUCCESS'
